import { useId } from "react";
import Routes from "./Routes";
import SkipLink from "./components/SkipLink";
import { Analytics } from "./components/Analytics";

function App() {
  const mainContentId = useId();
  
  return (
    <>
      <Analytics />
      <SkipLink targetId={mainContentId} />
      <div id={mainContentId} tabIndex="-1">
        <Routes />
      </div>
    </>
  );
}

export default App;
